if (!customElements.get('tabs-section-image-tabs')) {
  customElements.define('tabs-section-image-tabs', class extends HTMLElement {
    connectedCallback() {
      const outerPanel = this.closest('[data-wbs-pck-panel]');
      if (outerPanel) {
        this.visibilityObserver = new MutationObserver(() => {
          if (outerPanel.getAttribute('aria-hidden') === 'true') this.pauseVideos();
        });
        this.visibilityObserver.observe(outerPanel, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[data-image-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-image-panel]'));
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-image-tab]');
        if (this.tabs.includes(tab)) this.selectTab(tab);
      });
      this.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.selectTab(this.tabs[next]);
        this.tabs[next].focus();
      });
    }

    disconnectedCallback() {
      this.pauseVideos();
      if (this.visibilityObserver) this.visibilityObserver.disconnect();
    }

    pauseVideos() {
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        const active = tab === selectedTab;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
        if (panel.hidden) panel.querySelectorAll('video').forEach((video) => video.pause());
      });
    }
  });
}
